import { useQuery } from '@tanstack/react-query';
import Config from 'config/Config';
import { fetcher } from 'services/fetcher';
import { deserializeDictionary } from './deserializer';

async function getCompleteDictionary() {
  return fetcher(Config.GET_COMPLETE_DICTIONARY).then(deserializeDictionary);
}

export function useDictionary() {
  return useQuery({
    queryKey: ['dictionary'],
    queryFn: getCompleteDictionary,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
